import type { UpdateCompanyFormData } from '../schemas/company.schemas';
import type { Company } from '../types/company.types';

export const ACCEPTED_IMAGE_TYPES = 'image/png,image/jpeg,image/webp,image/svg+xml';

export const toFormValues = (c: Company): UpdateCompanyFormData => ({
  name: c.name,
  email: c.email,
  phone: c.phone ?? '',
  industry: c.industry ?? '',
  companySize: c.companySize,
  country: c.country ?? '',
  city: c.city ?? '',
  address: c.address ?? '',
  description: c.description ?? '',
  website: c.website ?? '',
  taxId: c.taxId ?? '',
});
